import {
  IStateInitiativeDataIds,
  IStateInitiativeFilters,
} from "./StateInitiative.type";
import {LIFE_CYCLE_VALUES} from "../../components/ClusterFilter/data";

export const initialStateInitiativeFilters: IStateInitiativeFilters = {
  priority_level: {
    value: 0,
    turnOn: false,
  },
  gpb: {
    value: "all",
    turnOn: false,
  },
  business_impact: {
    value: 0,
    turnOn: false,
  },
  lobbying_capability: {
    value: 0,
    turnOn: false,
  },
  lifecycle_stage: {
    value: [...LIFE_CYCLE_VALUES],
    turnOn: false,
  },
  obligation_level: {
    value: ["Обязательно", "Рекомендовано", "Добровольно"],
    turnOn: false,
  },
  participation_formats: {
    value: ["Обязательный участник", "Пилот", "Экспертные обсуждения"],
    turnOn: false,
  },
  influence_zone: {
    value: [], // Будет заполнено динамически после загрузки impact areas
    turnOn: false,
  },
  // ОТКЛЮЧЕНО: драйверы временно не используются
  // drivers: {value: [], turnOn: false},
};

export const initialStateInitiativeDataIds: IStateInitiativeDataIds = {
  directionId: null,
  directionName: "",
  trendId: null,
  trendName: "",
  currentSector: "",
  initiativeData: null,
};
